export const reportCategories = [
  { value: 'underage', label: 'Возможно, пользователь младше 18 лет' },
  { value: 'impersonation', label: 'Выдаёт себя за другого человека' },
  { value: 'harassment', label: 'Оскорбления или преследование' },
  { value: 'sexual_coercion', label: 'Сексуальное давление или принуждение' },
  { value: 'spam_scam', label: 'Спам или мошенничество' },
  { value: 'money_crypto', label: 'Просит деньги или криптовалюту' },
  { value: 'hate_violence', label: 'Ненависть, угрозы или насилие' },
  { value: 'privacy', label: 'Нарушение приватности' },
  { value: 'other', label: 'Другая причина' },
] as const;

export type ReportCategory = (typeof reportCategories)[number]['value'];

export function buildReportRequest(input: {
  targetUserId: string;
  conversationId: string;
  category: ReportCategory;
  details: string;
  block: boolean;
}) {
  const details = input.details.trim();
  return {
    targetUserId: input.targetUserId,
    conversationId: input.conversationId,
    category: input.category,
    ...(details ? { details } : {}),
    evidenceMessageIds: [],
    block: input.block,
  };
}

export function buildUnmatchRequest(reasonCode: string) {
  const reason = reasonCode.trim();
  return reason ? { reasonCode: reason } : {};
}
